import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'house-user',
        link: '/',
    },
    {
        id: 2,
        label: 'MENUITEMS.MISCITAS.TEXT',
        icon: 'calendar-check',
        link: '/',
        fragment: 'misCitas'
    },
    {
        id: 2,
        label: 'MENUITEMS.PAQUETES.TEXT',
        icon: 'box-open',
        link: 'listado-paquetes',
        fragment: 'listadoPaquetes'
    },
    {
        id: 2,
        label: 'MENUITEMS.MISPAQUETES.TEXT',
        icon: 'box',
        link: '/mis-paquetes',
        fragment: 'misPaquetes'
    },
    {
        id: 2,
        label: 'MENUITEMS.PERFIL.TEXT',
        icon: 'user',
        link: '/perfil',
    },
    {
        id: 2,
        label: 'Historial de Citas',
        icon: 'history',
        link: '/historial-citas',
    },
    {
        id: 8,
        label: 'MENUITEMS.DIARIOEMOCIONES.TEXT',
        icon: 'heart',
        link: '/diario-emociones',
    },
    {
        id: 9,
        label: 'Ayuda',
        icon: 'question-circle',
        link: '/ayuda',
    }


];

